"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormulaLibrary = void 0;
const conditionals_1 = require("./conditionals");
const date_1 = require("./date");
const strings_1 = require("./strings");
const math_1 = require("./math");
const window_1 = require("./window");
__exportStar(require("./conditionals"), exports);
__exportStar(require("./date"), exports);
__exportStar(require("./strings"), exports);
__exportStar(require("./math"), exports);
__exportStar(require("./window"), exports);
const dateLibrary = {
    DATEADD: date_1.DATEADD,
    DATEFORMAT: date_1.DATEFORMAT,
    ISDATE: date_1.ISDATE,
    DAY: date_1.DAY,
    WEEKDAY: date_1.WEEKDAY,
    WEEKNUM: date_1.WEEKNUM,
    MONTH: date_1.MONTH,
    YEAR: date_1.YEAR,
    DATE: date_1.DATE,
    TODAY: date_1.TODAY,
    DATEDIF: date_1.DATEDIF,
    DATEVALUE: date_1.DATEVALUE,
    EOMONTH: date_1.EOMONTH,
    DATEONLY: date_1.DATEONLY,
};
const conditionalLibrary = {
    IF: conditionals_1.IF,
    IFERROR: conditionals_1.IFERROR,
    AND: conditionals_1.AND,
    OR: conditionals_1.OR,
    NOT: conditionals_1.NOT,
    CONTAINS: conditionals_1.CONTAINS,
    COALESCE: conditionals_1.COALESCE,
    IN: conditionals_1.IN,
};
const stringLibrary = {
    CONCAT: strings_1.CONCAT,
    REGEX_REPLACE: strings_1.REGEX_REPLACE,
    REGEX_EXTRACT: strings_1.REGEX_EXTRACT,
    SUBSTITUTE: strings_1.SUBSTITUTE,
    SUBSTITUTES: strings_1.SUBSTITUTES,
    TRIM: strings_1.TRIM,
    RIGHT: strings_1.RIGHT,
    LEFT: strings_1.LEFT,
    UPPER: strings_1.UPPER,
    LOWER: strings_1.LOWER,
    PROPER: strings_1.PROPER,
    TEXT: strings_1.TEXT,
    LEN: strings_1.LEN,
    ISBLANK: strings_1.ISBLANK,
    FIND: strings_1.FIND,
    MID: strings_1.MID,
    PADLEFT: strings_1.PADLEFT,
    PADRIGHT: strings_1.PADRIGHT,
    JSON_EXTRACT: strings_1.JSON_EXTRACT,
    REMOVE_DIACRITICS: strings_1.REMOVE_DIACRITICS,
    SPLIT: strings_1.SPLIT,
};
const mathLibrary = {
    INT: math_1.INT,
    NUMBERVALUE: math_1.NUMBERVALUE,
    ROUND: math_1.ROUND,
    ROUNDDOWN: math_1.ROUNDDOWN,
    ROUNDUP: math_1.ROUNDUP,
    ISNUMBER: conditionals_1.ISNUMBER,
    MAX: math_1.MAX,
    MIN: math_1.MIN,
    AVERAGE: math_1.AVERAGE,
};
const windowLibrary = {
    ROLLING_SUM: window_1.ROLLING_SUM,
};
exports.FormulaLibrary = {
    ...dateLibrary,
    ...conditionalLibrary,
    ...stringLibrary,
    ...mathLibrary,
    ...windowLibrary,
};
